var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"user-info"},[_c('div',{staticClass:"user-name"},[_vm._v(_vm._s(_vm.getName))]),_c('div',{staticClass:"user-email"},[_vm._v(_vm._s(_vm.getEmail))])])}
var staticRenderFns = []

export { render, staticRenderFns }